





















import Vue from 'vue'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { $, removeElement } from '@/utils/helpers'

export default Vue.extend({
  name: 'AmataModal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    animation: {
      type: String,
      default: 'zoom-out'
    },
    canCancel: {
      type: [Array, Boolean],
      default: () => ['escape', 'x', 'outside', 'button']
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    props: {
      type: Object,
      default: null
    },
    events: {
      type: Object,
      default: null
    },
    component: {
      type: [Object, Function],
      default: null
    },
    content: {
      type: String,
      default: ''
    },
    fullSize: {
      type: Boolean,
      default: false
    },
    programmatic: {
      type: Boolean,
      default: false
    },
    swipable: {
      type: Boolean,
      default: true
    },
    scrollLock: {
      type: Boolean,
      default: false
    },
    scrollEnableSelector: {
      type: String,
      default: ''
    },
    hasSideMargin: {
      type: Boolean,
      default: false
    }
  },
  // TODO: なぜか props が型推論できない
  data(this: any) {
    return {
      isActive: this.active || false,
      lockingScroll: false,
      scrollEnableTarget: null
    }
  },
  computed: {
    cancelOptions(this: any) {
      if (typeof this.canCancel === 'boolean') {
        return this.canCancel ? ['escape', 'x', 'outside', 'button'] : []
      } else {
        return this.canCancel
      }
    },
    showX(this: any) {
      return this.cancelOptions.indexOf('x') >= 0
    }
  },
  watch: {
    active(val) {
      this.isActive = val
    }
  },
  beforeMount(this: any) {
    this.programmatic && document.body.appendChild(this.$el)
  },
  async mounted(this: any) {
    if (this.programmatic) {
      this.isActive = true
    }

    if (this.scrollLock && $('body').style.overflow !== 'hidden') {
      // すでにロック中でなければ
      await this.$nextTick()
      if (this.scrollEnableSelector !== '') {
        this.scrollEnableTarget = document.querySelector(this.scrollEnableSelector)
      }
      disableBodyScroll(this.scrollEnableTarget)
      this.lockingScroll = true
    }
  },
  destroyed(this: any) {
    if (this.scrollLock && this.lockingScroll) {
      enableBodyScroll(this.scrollEnableTarget)
      this.scrollEnableTarget = null
      this.lockingScroll = false
    }
  },
  methods: {
    /**
     * Close the Modal if canCancel and call the onCancel prop (function).
     */
    cancel(this: any, method) {
      if (this.cancelOptions.indexOf(method) < 0) {
        return
      }
      this.onCancel.apply(null, arguments)
      this.close()
    },

    /**
     * スワイプダウンで閉じる
     */
    onSwipeDown(this: any) {
      if (!this.swipable) {
        return
      }
      this.cancel('outside')
    },

    /**
     * Keypress event that is bound to the document.
     */
    keyPress(this: any, event) {
      // Esc key
      if (this.isActive && event.keyCode === 27) {
        this.cancel('escape')
      }
    },

    close(this: any) {
      this.$emit('onClose')
      this.$emit('update:active', false)

      if (this.programmatic) {
        this.isActive = false
        setTimeout(() => {
          this.$destroy()
          removeElement(this.$el)
        }, 150)
      }
    }
  }
})
